import { render, staticRenderFns } from "./RedemptionApprovals.vue?vue&type=template&id=dbacd9ca&scoped=true&"
import script from "./RedemptionApprovals.vue?vue&type=script&lang=js&"
export * from "./RedemptionApprovals.vue?vue&type=script&lang=js&"
import style0 from "./RedemptionApprovals.vue?vue&type=style&index=0&id=dbacd9ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbacd9ca",
  null
  
)

export default component.exports